<template>
  <InputDate
    :key="filtro.filtro"
    :text="text"
    :filtro="filtro"
    :campo="filtro"
    :intervalo-data="intervaloData"
    @aplicarFiltro="aplicarFiltro"
    @dateRangeSelected="onDateRangeSelected"
    @dateRangeCleared="onDateRangeCleared"
    @update:text="onUpdateText"
    :path="path"
  />
</template>
<script>
import InputDate from '../../components/InputDate.vue';
export default {
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    InputDate
  },
  data() {
    return {
      selectedDateRange: {
        inicio: '',
        fim: ''
      },
      text: ''
    };
  },
  computed: {
    intervaloData() {
      const filtros = this.$store.state.filtroAplicados;
      const inicioKey = `${this.filtro.filtro}_ini`;
      const fimKey = `${this.filtro.filtro}_fim`;
      
      return {
        inicio: filtros[inicioKey] || '',
        fim: filtros[fimKey] || ''
      };
    }
  },
  watch: {
    intervaloData: {
      handler(newVal) {
        if (!newVal || !newVal.inicio || !newVal.fim) return;

        const inicioMoment = moment(newVal.inicio, 'DD/MM/YYYY');
        const fimMoment = moment(newVal.fim, 'DD/MM/YYYY');
        
        if (!inicioMoment.isValid() || !fimMoment.isValid()) return;

        this.selectedDateRange = {
          inicio: newVal.inicio,
          fim: newVal.fim
        };
        
        const inicio = newVal.inicio.replaceAll('-', '/');
        const fim = newVal.fim.replaceAll('-', '/');
        if (inicio === fim) {
          this.text = inicio;
        } else {
          this.text = `${inicio} - ${fim}`;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onDateRangeSelected(data) {
      this.selectedDateRange = data;
      
      const inicio = data.inicio.replaceAll('-', '/');
      const fim = data.fim.replaceAll('-', '/');
      if (inicio === fim) {
        this.text = inicio;
      } else {
        this.text = `${inicio} - ${fim}`;
      }
      
      this.aplicarFiltro();
    },
    onDateRangeCleared() {
      this.selectedDateRange = { inicio: '', fim: '' };
      this.text = '';
      this.aplicarFiltro();
    },
    aplicarFiltro() {
      if (!this.selectedDateRange.inicio || !this.selectedDateRange.fim) return;

      const inicio = this.selectedDateRange.inicio.replaceAll('-', '/');
      const fim = this.selectedDateRange.fim.replaceAll('-', '/');

      this.$aplicaFiltroEmURL(`${this.filtro.filtro}_ini`, inicio, this.path);
      this.$store.commit('addFiltroAplicado', {
        filtro: `${this.filtro.filtro}_ini`,
        valor: inicio
      });
      
      this.$aplicaFiltroEmURL(`${this.filtro.filtro}_fim`, this.selectedDateRange.fim.replaceAll('-', '/'), this.path);
      this.$store.commit('addFiltroAplicado', {
        filtro: `${this.filtro.filtro}_fim`,
        valor: fim
      });
    },
    onUpdateText(text) {
      this.text = text;
    }
  },
  mounted() {
    const filtros = this.$store.state.filtroAplicados;
    const inicioKey = `${this.filtro.filtro}_ini`;
    const fimKey = `${this.filtro.filtro}_fim`;
    
    if (filtros[inicioKey] && filtros[fimKey]) {
      this.selectedDateRange = {
        inicio: filtros[inicioKey],
        fim: filtros[fimKey]
      };
      
      const inicio = this.selectedDateRange.inicio.replaceAll('-', '/');
      const fim = this.selectedDateRange.fim.replaceAll('-', '/');
      if (inicio === fim) {
        this.text = inicio;
      } else {
        this.text = `${inicio} - ${fim}`;
      }
    } else if (filtros.hasOwnProperty(this.filtro.filtro)) {
      this.text = filtros[this.filtro.filtro];
    }
  },
  beforeUnmount() {
    this.selectedDateRange = { inicio: '', fim: '' };
    this.text = '';
  }
}
</script>